<mat-dialog-content class="contract-active">
  <h4>Variable de contrato</h4>

  <form [formGroup]="userContractForm">
    <div class="container" style="margin-top: 5px">
      <h5 class="section-title">Posición y dedicación</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Categoría departamento</mat-label>
            <mat-select formControlName="department_category_ids" multiple>
              @for (dc of department_categories; track dc) {
                <mat-option [value]="dc.id">{{ dc.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Horas estimadas semanales</mat-label>
            <input type="number" min="0" matInput formControlName="hours_per_week_expected" />
            <mat-hint>Jornada completa == 40h</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Días permitidos de teletrabajo</mat-label>
            <input type="number" min="1" max="7" matInput formControlName="allowed_remote_work_days" />
            <mat-hint style="font-style: italic"> Por defecto: {{ allowed_remote_work_days_fallback_from_department_category }} </mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>% producción esperada</mat-label>
            <input type="number" min="0" max="100" matInput formControlName="expected_production_prcnt" />
            @if (
              userContractForm.get('expected_production_prcnt')?.enabled &&
              $safeNavigationMigration(userContractForm.get('expected_production_prcnt')?.value) !== null &&
              userContractForm.get('expected_production_prcnt')?.value !== ''
            ) {
              <button mat-icon-button matSuffix type="button" (click)="clearExpectedProductionPrcnt()">
                <mat-icon>close</mat-icon>
              </button>
            }
            <span matSuffix style="padding-right: 8px">%</span>
            <mat-hint style="font-style: italic">
              Por defecto: {{ expected_production_prcnt_fallback_from_department_category }}%
            </mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12">
          <mat-form-field class="nobottom" appearance="outline" class="w-100">
            <mat-label>Descripción de trabajo</mat-label>
            <textarea
              matInput
              formControlName="job_description"
              cdkTextareaAutosize
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="15"
              maxlength="255"
            ></textarea>
          </mat-form-field>
        </div>
      </div>

      <h5 class="section-title">Retribución</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          @if (useDefaultSalary) {
            <div>
              <p>Salario recomendado según categoria: {{ brute_anual_base_salary_from_contract | currency }}</p>

              <mat-checkbox formControlName="use_default_salary" [disabled]="!canManageUserContractForm">
                Por defecto de la tabla salarial
              </mat-checkbox>
            </div>
          } @else {
            <mat-form-field
              appearance="outline"
              style="width: 100%"
              [style.margin-bottom]="
                permissions.validateDepartment(['direction', 'rrhh']) && brute_anual_base_salary_from_contract ? '25px' : '0px'
              "
            >
              <mat-label>Salario bruto base anual</mat-label>
              <input type="number" matInput formControlName="brute_anual_base_salary" />
              <span matSuffix style="padding-right: 8px">€</span>
              @if (permissions.validateDepartment(['direction', 'rrhh'])) {
                <mat-hint style="font-style: italic"
                  >Salario recomendado según categoria: {{ brute_anual_base_salary_from_contract | currency }}</mat-hint
                >
              }
            </mat-form-field>
            <div>
              <mat-checkbox formControlName="use_default_salary" [disabled]="!canManageUserContractForm">
                Por defecto de la tabla salarial
              </mat-checkbox>
            </div>
          }
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field appearance="outline" class="nobottom">
            <mat-label>Plus anual por antigüedad (trienios)</mat-label>
            <input
              matInput
              type="number"
              disabled
              [value]="working_contract.current_working_contract_variable_condition.current_triennium_anual_salary"
            />
            <span matSuffix style="padding-right: 8px">€</span>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          @if (useDefaultFlexibleRemuneration) {
            <div>
              <p>Ret. flexible recomendado según categoria: {{ flexible_remuneration_monthly_quantity_from_contract | currency }}</p>
              <mat-checkbox formControlName="use_default_flexible_remuneration"> Por defecto de la tabla salarial </mat-checkbox>
            </div>
          } @else {
            <mat-form-field
              appearance="outline"
              style="width: 100%"
              [style.margin-bottom]="
                permissions.validateDepartment(['direction', 'rrhh']) && flexible_remuneration_monthly_quantity_from_contract
                  ? '25px'
                  : '0px'
              "
            >
              <mat-label>Ret. flexible mensual</mat-label>
              <input
                type="number"
                matInput
                formControlName="flexible_remuneration_monthly_quantity"
                [disabled]="!canManageUserContractForm"
              />
              <span matSuffix style="padding-right: 8px">€</span>
              @if (permissions.validateDepartment(['direction', 'rrhh'])) {
                <mat-hint style="font-style: italic"
                  >Ret. flexible recomendado según categoria:
                  {{ flexible_remuneration_monthly_quantity_from_contract | currency }}</mat-hint
                >
              }
            </mat-form-field>

            <div>
              <mat-checkbox formControlName="use_default_flexible_remuneration" [disabled]="!canManageUserContractForm">
                Por defecto de la tabla salarial
              </mat-checkbox>
            </div>
          }
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Nº de pagas anuales</mat-label>
            <mat-select formControlName="number_of_payments_per_year">
              <mat-option [value]="12">12 pagas</mat-option>
              <mat-option [value]="14">14 pagas</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Precio hora</mat-label>
            <input type="number" matInput formControlName="price_per_hour" />
            <span matSuffix style="padding-right: 8px">€/h</span>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-checkbox formControlName="extract_flexible_remuneration_from_salary">
            ¿Extraer retribución flexible del salario?
          </mat-checkbox>
        </div>
      </div>

      <h5 class="section-title">Antigüedad y previsión</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Antigüedad calculada sobre</mat-label>
            <mat-select formControlName="seniority_plus_based_on">
              <mat-option value="full_salary">Salario completo</mat-option>
              <mat-option value="base_salary">Salario base</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-checkbox formControlName="possible_future_early_retirement">¿Existe posibilidad de prejubilación?</mat-checkbox>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-checkbox formControlName="possible_future_retirement_plan">¿Existe posibilidad de plan de pensiones?</mat-checkbox>
        </div>
      </div>

      <h5 class="section-title">Impuestos y cotización</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>% medio IRPF en nómina</mat-label>
            <input type="number" min="0" max="100" matInput formControlName="irpf_prcnt_avg_in_payrolls_for_worker" />
            <span matSuffix style="padding-right: 8px">%</span>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>% medio S.S. trabajador</mat-label>
            <input type="number" min="0" max="100" matInput formControlName="seguridad_social_prcnt_avg_for_worker" />
            <span matSuffix style="padding-right: 8px">%</span>
          </mat-form-field>
        </div>
      </div>

      <h5 class="section-title">Horas no productivas (overrides)</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-6">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Max. horas no productivas/semana (custom)</mat-label>
            <input type="number" min="0" matInput formControlName="custom_max_non_productive_hours_per_week_assuming_fulltime" />
            @if (
              userContractForm.get('custom_max_non_productive_hours_per_week_assuming_fulltime')?.enabled &&
              $safeNavigationMigration(userContractForm.get('custom_max_non_productive_hours_per_week_assuming_fulltime')?.value) !==
                null &&
              userContractForm.get('custom_max_non_productive_hours_per_week_assuming_fulltime')?.value !== ''
            ) {
              <button mat-icon-button matSuffix type="button" (click)="clearCustomMaxNonProductiveHours()">
                <mat-icon>close</mat-icon>
              </button>
            }
            <mat-hint style="font-style: italic">
              Por defecto: {{ custom_max_non_productive_hours_fallback_from_department_category }}h
            </mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-6">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Categoría por defecto horas no productivas (custom)</mat-label>
            <input
              type="text"
              matInput
              [matAutocomplete]="customCatAuto"
              formControlName="custom_non_productive_hours_default_working_time_category"
              placeholder="Buscar categoría..."
            />
            @if (
              userContractForm.get('custom_non_productive_hours_default_working_time_category')?.enabled &&
              userContractForm.get('custom_non_productive_hours_default_working_time_category')?.value
            ) {
              <button mat-icon-button matSuffix type="button" (click)="clearCustomCategory()">
                <mat-icon>close</mat-icon>
              </button>
            }
            <mat-autocomplete
              #customCatAuto="matAutocomplete"
              [displayWith]="displayFnWorkingTimeCategory"
              (optionSelected)="onCustomCategorySelected($event.option.value)"
            >
              @for (c of filtered_working_time_categories; track c.id) {
                <mat-option [value]="c">{{ c.name }}</mat-option>
              }
            </mat-autocomplete>
            <mat-hint style="font-style: italic">
              Por defecto: {{ custom_non_productive_hours_default_wtc_fallback_from_department_category?.name ?? '—' }}
            </mat-hint>
          </mat-form-field>
        </div>
      </div>

      <h5 class="section-title">Guardia</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Guardian: Salario bruto semanal</mat-label>
            <input type="number" matInput formControlName="guardian_weekly_salary" />
            <span matSuffix style="padding-right: 8px">€</span>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Guardian: Plus por atender cliente</mat-label>
            <input type="number" matInput formControlName="guardian_trigger_attended_salary" />
            <span matSuffix style="padding-right: 8px">€</span>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <mat-form-field class="nobottom" appearance="outline">
            <mat-label>Guardian: Precio por hora</mat-label>
            <input type="number" matInput formControlName="guardian_price_per_hour" />
            <span matSuffix style="padding-right: 8px">€/h</span>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

@if (!formShouldBeDisabled) {
  <mat-dialog-actions align="end">
    @if (canManageUserContractForm) {
      <button
        mat-flat-button
        color="accent"
        (click)="askSaveContractWithPropagation()"
        type="submit"
        [disabled]="!userContractForm.valid || !hasUnsavedChanges()"
      >
        <mat-icon matPrefix>save</mat-icon>
        Guardar
      </button>
    }
  </mat-dialog-actions>
}
